import {
  defineUIInstanceCatalog,
  semanticSurface,
  UIAction,
  UIResource,
} from '@amzn/takt-semantics';
import { chromeComponents } from 'src/constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';

// Snake_case of the registered page-header component id; pinned by a conformance test.
export const PAGE_HEADER_SURFACE = 'aac_chrome_page_header';

export const pageHeaderInstances = defineUIInstanceCatalog({
  chrome: {
    [UIResource.BUTTON]: {
      PAGE_TITLE_ICON: 'page_title_icon',
      ACTIVATION: 'activation',
    },
  },
});

const chrome = semanticSurface(PAGE_HEADER_SURFACE, {
  instances: pageHeaderInstances,
}).chrome();

// Emits the favourite/star toggle's resulting saved-state; wrapped so a throwing client cannot break the toggle.
export const emitPageTitleIconToggle = (isActive: boolean): void => {
  try {
    chrome.emitControl(
      UIResource.BUTTON,
      isActive ? UIAction.ACTIVATE : UIAction.DEACTIVATE,
      pageHeaderInstances.chrome[UIResource.BUTTON].PAGE_TITLE_ICON,
    );
  } catch {
    // emit is non-essential; the toggle must proceed regardless
  }
};

// Declarative twin for the header activation/toggle; legacy id stays byte-for-byte on the same node.
export const activationTwinAttributes = (id: string, active: boolean) => {
  const legacy = getTaktAttributes(id, chromeComponents.HEADER);
  if (!legacy) return undefined;
  return chrome.control(
    UIResource.BUTTON,
    active ? UIAction.DEACTIVATE : UIAction.ACTIVATE,
    pageHeaderInstances.chrome[UIResource.BUTTON].ACTIVATION,
    { legacy: { id: legacy['data-takt-id'] } },
  );
};
